<template>
    <div
            class="input-error"
            v-if="fieldErrors.length"
    >
        <transition-group
                name="fade"
                tag="div"
        >
            <b-form-invalid-feedback
                    class="mt-1 d-flex"
                    v-for="(message,i) in fieldErrors"
                    :key="i+1"

                    :state="true"
                    :force-show="true"
            >
                <i
                    class="far fa-exclamation-circle text-danger error-icon w-auto"
                />
                <div v-html="`${message.ucFirst()}`" />
            </b-form-invalid-feedback>
        </transition-group>
        <br>
    </div>
</template>

<script>
    import get from 'lodash/get';

    export default {
        name: 'FormErrors',
        props: {
            errors: {
                type: [Object, Array],
                required: true,
            },
            field: {
                type: [String],
                required: false,
            },
            dotField: {
                type: String,
            },
        },
        data() {
            return {};
        },
        watch: {
            errors() {
            },
        },
        computed: {
            fieldErrors() {
                let errors = [];
                if (this.dotField) {
                    const errorsStack = this.errors[this.dotField];
                    if (this.field) {
                        errors = get(errorsStack, this.field);
                    } else {
                        errors = errorsStack;
                    }
                } else {
                    errors = get(this.errors, this.field);
                }
                return typeof errors === 'string' ? [errors] : (errors || []);
            },
        },
    };
</script>
